import { lazy, useMemo } from "react";
import { getEnvBrand } from "utils/hooks/useSalesNetworks";

export const BrandComponent = {
  Layout: "layout",
  Home: "home",
  Favicon: "styles/favicon.ico",
};

export const useBrandComponent = (component: string) => {
  const Component = useMemo(
    () => 
      lazy(() => {
        const brand = getEnvBrand();
        const body = document.getElementsByTagName("html")[0];
        body.setAttribute("data-name", brand)
        const a = import(`./${brand}/${component}/index.tsx`);
        return a;
      })
      ,
    [component]
  );

  return Component
    ;
};
